export default __webpack_public_path__ + "static/media/ic_convert_down.d11686d3.svg";